<template>
  <div v-if="dialog.visible" class="app-modal-overlay">
    <div class="app-dialog-container" @click.stop>
      <div class="app-dialog-title">{{ dialog.title }}</div>
      <div class="app-dialog-text">{{ dialog.text }}</div>
      <div class="app-dialog-actions">
        <button
          v-for="(button, index) in dialog.buttons"
          :key="index"
          class="btn-heartbeat small white"
          @click="handleButtonClick(button)"
        >
          {{ button.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getModalApi } from '@/plugins/modal-manager';

export default {
  name: 'AppDialogModal',
  data () {
    return {
      modalApi: getModalApi()
    };
  },
  computed: {
    dialog () {
      return this.modalApi.state.dialog;
    }
  },
  methods: {
    handleButtonClick (button) {
      if (button && typeof button.handler === 'function') {
        button.handler();
      } else {
        this.modalApi.hide('dialog');
      }
    }
  }
};
</script>

<style scoped>
.app-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.app-dialog-container {
  width: min(520px, calc(100vw - 32px));
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.app-dialog-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}

.app-dialog-text {
  margin-bottom: 24px;
  line-height: 1.5;
}

.app-dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
